<template>
    <v-bottom-sheet
        :value="dialog"
        content-class="half-round"
        persistent
        absolute
        hide-overlay
        :retain-focus="false"
        attach="#shoppingCart"
        transition=""
    >
        <v-card
            :class="[
                'half-round',
                $vuetify.breakpoint.mdAndUp ? 'pb-3' : null,
                {
                    'pb-16':
                        (!$page.props.profileComplete &&
                            !$page.props.profileRequired) ||
                        $page.props.impersonating?.impersonatingUser,
                },
            ]"
            ><v-card-title class="soli-grey">Checkout</v-card-title>
            <v-card-subtitle class="pb-0">{{
                $page.props.auth.user.selected_location.name
            }}</v-card-subtitle>

            <v-container
                v-if="checkoutLoading"
                class="flex justify-center align-center"
            >
                <v-progress-circular
                    color="primary"
                    indeterminate
                    size="54"
                ></v-progress-circular>
            </v-container>
            <v-container class="pt-0 px-5" v-if="!checkoutLoading">
                <v-tabs v-model="tabs" class="px-1 mb-3">
                    <v-tab
                        :disabled="!client.defaultMethod"
                        @click="
                            [
                                clearPaymentMethods(),
                                (selectPaymentMethod.default.value = true),
                            ]
                        "
                        >Default</v-tab
                    >
                    <v-tab @click="clearPaymentMethods()">New Card</v-tab>
                    <v-tab @click="clearPaymentMethods()">Promo</v-tab>
                    <v-tab
                        v-if="can('Create invoices')"
                        @click="
                            [
                                clearPaymentMethods(),
                                (selectPaymentMethod.invoice.value = true),
                            ]
                        "
                        >Invoice</v-tab
                    >
                </v-tabs>

                <v-tabs-items v-model="tabs">
                    <v-tab-item
                        ><div :class="['pa-3 ma-0 soli-round']">
                            <v-row
                                v-if="client.defaultMethod"
                                class="align-center pa-3"
                            >
                                <v-col class="col-1 px-0"
                                    ><v-icon color="rgba(0,0,0,.54)"
                                        >credit_card</v-icon
                                    ></v-col
                                >
                                <v-col class="pl-0 py-0">
                                    <v-list class="mx-2">
                                        <div class="caption soli-grey">
                                            {{
                                                client.defaultMethod
                                                    .billing_details?.name
                                            }}
                                        </div>
                                        <div
                                            :class="[
                                                'soli-grey',
                                                $vuetify.breakpoint.xsOnly
                                                    ? 'body-2'
                                                    : 'body-1',
                                            ]"
                                        >
                                            {{
                                                client.defaultMethod.card.brand
                                            }}
                                            ****
                                            {{
                                                client.defaultMethod.card.last4
                                            }}
                                        </div>
                                        <div class="caption soli-grey">
                                            Expires
                                            {{
                                                client.defaultMethod.card
                                                    .exp_month
                                            }}/{{
                                                client.defaultMethod.card.exp_year
                                                    .toString()
                                                    .slice(-2)
                                            }}
                                        </div>
                                    </v-list>
                                </v-col>
                            </v-row>
                        </div></v-tab-item
                    >
                    <v-tab-item>
                        <v-container>
                            <div v-if="cardCapture">
                                <div class="soli-grey">
                                    Please use card reader to complete this
                                    transaction.
                                </div>
                            </div>

                            <div v-show="selectPaymentMethod.manualCard.value">
                                <!-- Display a payment form -->
                                <form id="payment-form">
                                    <div id="payment-element">
                                        <!-- Elements will create form elements here -->
                                    </div>
                                    <div id="error-message">
                                        <!-- Display error message to your customers here -->
                                    </div>
                                </form>
                            </div>

                            <div
                                v-if="
                                    total == 0 ||
                                    (!cardCapture &&
                                        !selectPaymentMethod.manualCard.value)
                                "
                            >
                                <div class="flex justify-center">
                                    <v-btn-toggle v-model="selectCardOption"
                                        ><div>
                                            <v-btn
                                                @click="connectReaderHandler()"
                                                outlined
                                                :loading="terminalLoading"
                                                :large="
                                                    $vuetify.breakpoint.smAndUp
                                                "
                                                :disabled="total == 0"
                                                class="soli-blue-text soli-round"
                                                style="min-height: 64px"
                                                >Card Reader</v-btn
                                            >
                                            <v-btn
                                                @click="manualCardElement()"
                                                :loading="elementsLoading"
                                                outlined
                                                :large="
                                                    $vuetify.breakpoint.smAndUp
                                                "
                                                :disabled="total == 0"
                                                class="soli-blue-text soli-round"
                                                style="min-height: 64px"
                                                >Manual Entry</v-btn
                                            >
                                        </div></v-btn-toggle
                                    >
                                </div>
                            </div>

                            <v-row v-if="selectCardOption !== null">
                                <v-col
                                    cols="12"
                                    class="pb-0"
                                    style="height: 64px"
                                >
                                    <v-checkbox
                                        label="Save as default"
                                        :disabled="!defaultMethod"
                                        v-model="saveAsDefault"
                                    ></v-checkbox></v-col
                            ></v-row>
                        </v-container>
                    </v-tab-item>
                    <v-tab-item>
                        <div
                            class="flex gap-2 justify-between items-start py-4"
                        >
                            <v-form
                                @submit.prevent="applyPromo"
                                ref="promo"
                                class="flex-1"
                            >
                                <v-combobox
                                    ref="promoInput"
                                    v-model="promoCode"
                                    @change="applyPromo"
                                    outlined
                                    prepend-inner-icon="redeem"
                                    dense
                                    :disabled="activePromos.length > 0"
                                    append-icon=""
                                    :error-messages="errors.promo"
                                    :rules="promoRules"
                                    label="Gift or promo code"
                                    hide-details="auto"
                                >
                                    <template
                                        v-slot:selection="{
                                            attrs,
                                            item,
                                            select,
                                            selected,
                                        }"
                                    >
                                        <v-chip
                                            small
                                            v-bind="attrs"
                                            :input-value="selected"
                                            style="pointer-events: all"
                                            close
                                            @change="select"
                                            @click:close="
                                                promoCode = null;
                                                promoRules = [];
                                                $emit('clearPromo');
                                            "
                                        >
                                            {{ item }}
                                        </v-chip>
                                    </template></v-combobox
                                >
                            </v-form>
                            <SoliBtn
                                color="dark"
                                :class="{ 'mb-6': errors.promo }"
                                :loading="promoLoading"
                                :disabled="activePromos.length > 0"
                                @click="applyPromo"
                                >Apply</SoliBtn
                            >
                        </div></v-tab-item
                    >
                    <v-tab-item>
                        <v-row>
                            <v-card-title class="soli-grey">STOP</v-card-title>
                            <v-card-subtitle class="soli-grey">
                                <div
                                    class="soli-grey ml-3"
                                    style="text-indent: -7px"
                                >
                                    · This is not recommended.
                                </div>
                                <div
                                    class="soli-grey ml-3"
                                    style="text-indent: -7px"
                                >
                                    · This will invoice the client for this
                                    transaction and for any charges generated by
                                    memberships.
                                </div>
                                <div
                                    class="soli-grey ml-3"
                                    style="text-indent: -7px"
                                >
                                    · If an invoice is paid by check, you will
                                    be responsible for marking the invoice as
                                    paid.
                                </div>
                                <div
                                    class="soli-grey ml-3"
                                    style="text-indent: -7px"
                                >
                                    · If this customer already has an active
                                    membership, any memberships sold at this
                                    location
                                    <b
                                        >will continue billing the original
                                        payment method</b
                                    >.
                                </div>
                                <div
                                    class="soli-grey ml-3"
                                    style="text-indent: -7px"
                                >
                                    · Invoices will be sent to
                                    {{ client.email }}
                                </div></v-card-subtitle
                            >
                        </v-row></v-tab-item
                    >
                </v-tabs-items>
            </v-container>
            <v-container>
                <SoliBtn
                    :text="`${
                        selectPaymentMethod[currentState].text
                    } ${formatUnitAmount(total)}`"
                    @click="selectPaymentMethod[currentState].method"
                    gradient="gradient-orange"
                    :loading="loading"
                    :disabled="
                        total > 0 &&
                        (currentState == 'none' ||
                            terminalLoading ||
                            cardCapture)
                    "
                    block
                ></SoliBtn>
            </v-container>
        </v-card>
        <SoliChoice
            :title="readerError.title"
            :subtitle="readerError.subtitle"
            v-if="readerError"
            button1="Okay"
            @option1="readerError = false"
        ></SoliChoice>
    </v-bottom-sheet>
</template>

<script>
import Promos from "./Promos";
export default {
    props: [
        "client",
        "prices",
        "rules",
        "dialog",
        "errors",
        "total",
        "activePromos",
        "defaultMethod",
        "checkoutLoading",
        "contracts",
        "unpaidPOs",
        "taxRate",
        "selectedTab",
        "subtotal",
        "guestCheckout",
    ],
    components: { Promos },
    data() {
        return {
            cardHolderName: null,
            loading: false,
            cardCapture: false,
            terminal: null,
            terminalLoading: false,
            promoCode: null,
            //activePromos: [],
            promoRules: [],
            promoLoading: false,
            signedContract: null,
            loadContract: false,
            paymentIntent: null,
            swipedCard: null,
            tabs: this.client.defaultMethod ? 0 : 1,
            stripeElements: null,
            stripe: null,
            elementsLoading: false,
            saveAsDefault: true,
            selectCardOption: null,
            readerError: false,
            selectPaymentMethod: {
                manualCard: {
                    name: "manualCard",
                    value: false,
                    method: this.submitManualCard,
                    loading: false,
                    text: "Pay",
                },
                default: {
                    name: "default",
                    value: !!this.defaultMethod,
                    method: this.checkout,
                    loading: false,
                    text: "Pay",
                },
                terminal: {
                    name: "terminal",
                    value: false,
                    method: this.getCard,
                    loading: false,
                    text: "Pay",
                },
                invoice: {
                    name: "invoice",
                    value: false,
                    method: this.checkout,
                    loading: false,
                    text: "Invoice",
                },
                none: {
                    text: "Pay",
                    method: this.promoCheckout,
                    value: false,
                },
            },
        };
    },
    computed: {
        currentState() {
            let state = Object.values(this.selectPaymentMethod).find(
                (e) => e.value
            );
            if (!state) return "none";
            return state.name;
        },
    },
    methods: {
        promoCheckout() {
            if (this.total > 0) return null;
            this.checkout();
        },
        clearPaymentMethods() {
            Object.keys(this.selectPaymentMethod).forEach(
                (e) => (this.selectPaymentMethod[e].value = false)
            );
            this.selectCardOption = null;
            if (this.cardCapture) this.closeTerminal();
        },
        applyPromo() {
            this.promoLoading = true;
            this.promoRules.push((v) => !!v || "Required");

            if (!this.$refs.promo.validate()) {
                this.promoLoading = false;
                return;
            }

            //console.log(this.promoCode);
            if (this.promoCode.includes("GIFT-")) {
                this.redeemGift();
                return;
            }

            axios
                .get(
                    route("promo.search", {
                        code: this.promoCode,
                        prices: this.prices.map((e) => {
                            return {
                                id: e.price.id,
                                quantity: e.quantity,
                                tags: e.price.tags?.map((e) => e.name),
                            };
                        }),
                        customer_id: this.client.id,
                    })
                )
                .then((e) => {
                    if (e.data.error) {
                        this.$page.props.errors = { promo: e.data.error };
                        this.promoLoading = false;
                        setTimeout(() => {
                            this.promoRules = [];
                            this.$page.props.errors.promo = null;
                            this.promoCode = null;
                        }, 3000);
                    } else {
                        //this.activePromos.push(e.data);
                        this.$emit("applyPromo", e.data);
                        this.$page.props.successMessage = "Promo Applied!";
                        this.promoLoading = false;
                    }
                });
        },
        redeemGift() {
            this.$inertia.post(
                route("gift.redeem"),
                {
                    billingUser: this.client.id,
                    redemptionCode: this.promoCode,
                },
                {
                    onSuccess: (result) => {
                        setTimeout(() => {
                            this.$emit("success");
                            this.promoLoading = false;
                        }, 300);
                    },
                    onError: (errors) => {
                        console.log(errors);
                        this.promoLoading = false;
                    },
                }
            );
        },
        loadTerminal() {
            this.terminal = StripeTerminal.create({
                onFetchConnectionToken: this.fetchConnectionToken,
                onUnexpectedReaderDisconnect: this.unexpectedDisconnect,
            });
        },
        manualCardElement() {
            this.elementsLoading = true;

            const response = axios
                .get(route("stripe.payment"), {
                    params: { email: this.client.email },
                })
                .then((resp) => {
                    const clientSecret = resp.data.client_secret;
                    this.stripe = Stripe(resp.data.stripe_key);
                    const elements = this.stripe.elements({ clientSecret });
                    this.stripeElements = elements;

                    const paymentElement = elements.create("payment", {
                        wallets: { applePay: "never", googlePay: "never" },
                    });
                    paymentElement.mount("#payment-element");
                    paymentElement.on("ready", (event) => {
                        this.elementsLoading = false;
                        this.selectPaymentMethod.manualCard.value = true;
                    });
                    //setTimeout(() => {

                    //}, 1000);
                });
        },
        submitManualCard() {
            this.loading = true;
            const elements = this.stripeElements;
            this.stripe
                .confirmSetup({
                    elements,
                    confirmParams: {
                        return_url: route("store", {
                            tab: this.selectedTab,
                        }),
                    },
                    redirect: "if_required",
                })
                .then((resp) => {
                    if (resp.error) {
                        console.log(resp);
                        this.$page.props.errors = {
                            soliError: "Card Declined",
                        };
                        this.loading = false;
                    } else {
                        this.loading = false;
                        this.checkout();
                        // continue to subcontroller
                    }
                });
        },
        async fetchConnectionToken() {
            // Your backend should call /v1/terminal/connection_tokens and return the JSON response from Stripe
            const response = await axios.get("/cards/create");
            //console.log(response.data.secret);
            return response.data.secret;
        },
        unexpectedDisconnect() {
            // In this function, your app should notify the user that the reader disconnected.
            // You can also include a way to attempt to reconnect to a reader.
            console.log("Disconnected from reader");
            this.closeTerminal();
        },
        async connectReaderHandler() {
            this.selectPaymentMethod.terminal.value = true;
            let reader_location =
                this.$page.props.auth.user.selected_location.reader_location;
            console.log("location: " + reader_location);
            this.terminalLoading = true;
            this.loadTerminal();
            const config = { simulated: false, location: reader_location };
            const discoverResult = await this.terminal.discoverReaders(config);
            if (discoverResult.error) {
                console.log("Failed to discover: ", discoverResult.error);
                this.readerError = {
                    title: "Error",
                    subtitle:
                        "Something went wrong, please try again or contact kyle@musicologie.com",
                };
                this.terminalLoading = false;
                this.selectPaymentMethod.terminal.value = false;
            } else if (discoverResult.discoveredReaders.length === 0) {
                console.log("No available readers.");
                this.readerError = {
                    title: "Error",
                    subtitle: "No reader was found on this network.",
                };
                this.terminalLoading = false;
                this.selectPaymentMethod.terminal.value = false;
            } else {
                // Just select the first reader here.
                const selectedReader = discoverResult.discoveredReaders[0];

                const connectResult = await this.terminal.connectReader(
                    selectedReader
                );
                if (connectResult.error) {
                    console.log("Failed to connect: ", connectResult.error);
                    this.terminalLoading = false;
                    this.selectPaymentMethod.terminal.value = false;
                } else {
                    console.log(
                        "Connected to reader: ",
                        connectResult.reader.label
                    );
                    this.terminalLoading = false;
                    //this.cardCapture = true;
                    //this.collectPayment(this.terminal);
                    this.getCard();
                }
            }
        },
        getCard() {
            this.cardCapture = true;
            this.terminal.readReusableCard().then((resp) => {
                //console.log(resp);
                this.swipedCard = resp.payment_method.id;
                this.checkout();
            });
        },
        closeTerminal() {
            this.terminal.disconnectReader().then((e) => {
                console.log("Disconnected from terminal");
                this.cardCapture = false;
                this.loading = false;
            });
        },
        checkout() {
            this.loading = true;
            this.$inertia.post(
                route("subscriptions.store"),
                {
                    billingUser: this.client.email,
                    guestCheckout: this.guestCheckout,
                    unpaidPOs: this.unpaidPOs
                        ? this.unpaidPOs.map((e) => e.id)
                        : [],
                    payByInvoice: this.selectPaymentMethod.invoice.value,
                    defaultMethod: this.selectPaymentMethod.default.value,
                    total: this.total,
                    saveAsDefault: this.saveAsDefault,
                    swipedCard: this.swipedCard,
                    prices: this.prices
                        .filter((e) => e.price.interval)
                        .map((e) => {
                            return {
                                id: e.price.id,
                                product_id: e.id,
                                interval: e.price.interval,
                                stripe_id: e.price.stripe_id ?? null,
                                quantity: e.quantity,
                                contracts: e.contracts.map((e) => e.signed),
                                contract_name: e.contract.product_name,
                                description: e.description,
                                recipients: e.recipients.map((e) => e.id),
                                starts_at: e.starts_at,
                                anchor: e.anchor,
                                name: e.name,
                                amount: e.price.unit_amount,
                                proration: e.discounted
                                    ? e.proration - e.discounted
                                    : e.proration,
                                category: e.category,
                                access: e.access,
                                duration: e.price.duration,
                                passes: e.price.passes,
                                doNotBill: e.doNotBill,
                                is_event: !!e.is_event,
                                inline: !!e.price.inline,
                                package_name: e.price.package_name ?? null,
                                is_deposit: e.is_deposit ?? null,
                                required_product_id:
                                    e.required_product_id ?? null,
                                tags: e.price.tags?.map((e) => e.id),
                                futureDateMemberships: e.futureDateMembership,
                                coupon: null,
                                coupon_duration: e.price.coupon_duration,
                                restore_price_id: e.price.restore_price_id,
                            };
                        }),
                    contracts: this.contracts.map((e) => e.signed),
                    oneTime: this.prices
                        .filter((e) => !e.price.interval)
                        .map((e) => {
                            return {
                                id: e.price.id,
                                product_id: e.id,
                                interval: null,
                                stripe_id: e.price.stripe_id,
                                quantity: e.quantity,
                                recipients: e.recipients.map((e) => e.id),
                                name: e.name,
                                amount: e.price.unit_amount,
                                passes: e.price.passes,
                                guest_pass: e.guest_pass ? true : false,
                                category: e.category,
                                access: e.access ? e.access : null,
                                duration: e.price.duration,
                                unpaidPO: e.unpaidPO,
                                tax_rate: e.taxable ? this.taxRate.id : null,
                                physical: e.physical ? e.physical : null,
                                is_event: !!e.is_event,
                                inline: !!e.price.inline,
                                is_deposit: e.is_deposit ?? null,
                                required_product_id:
                                    e.required_product_id ?? null,
                                package_name: e.price.package_name ?? null,
                                contracts: e.contracts.map((e) => e.signed),
                                tags: e.price.tags?.map((e) => e.id),
                                contract_name: e.contract?.product_name,
                                coupon: null,
                                coupon_duration: null,
                                restore_price_id: null,
                            };
                        }),
                    promo_code_id: this.activePromos.length
                        ? this.activePromos[0].id
                        : null,
                },
                {
                    onSuccess: (result) => {
                        //console.log(result);
                        this.$emit("guestCheckout");
                        this.$emit("success");
                        this.loading = false;
                    },
                    onError: (errors) => {
                        console.log(errors);
                        this.loading = false;
                    },
                }
            );
        },
    },
    watch: {
        defaultMethod(value) {
            if (value) {
                this.selectPaymentMethod.default.value = true;
            }
        },
    },
    mounted() {
        //this.$refs.form.dialog = true;
        //if (!this.client.defaultMethod) this.connectReaderHandler();
    },
    beforeDestroy() {
        if (this.terminal) this.unexpectedDisconnect();
    },
};
</script>

<style></style>
